const request = require('superagent');

const TaxonAPI = {
    getTaxons: (storeId) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/multi_stores/${storeId}/taxonomies`)
        .set('Accept', 'application/json')
        .send()
        .then((response) => response.body),
};

export default TaxonAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/taxons.js
 **/